import React, { FC } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Switch } from "react-router";
import * as Sentry from "@sentry/react";
import { TopNav, SideNav } from "Components/Navigation";
import Routes from "Components/Routes/Routes";
import DPThemeProvider from "Styles/DPThemeProvider/DPThemeProvider";
import CssBaseline from "@material-ui/core/CssBaseline";
import GraphQlClientProvider from "Api/GraphQL/GraphQlClientProvider";
import { EnvNames } from "../Shared/env/envNames";
import { PartnerConfigProvider } from "Hooks/usePartnerConfig";
import AnalyticsConfig from "./Analytics/AnalyticsConfig";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import { Restricted } from "Components/Pages";
import LoginHandler from "./LoginHandler/LoginHandler";
import { InfoBanner } from "./Pages/DashboardPage/Overview/InfoBanner/InfoBanner";
import PermissionsVisualizerContext from "./PermissionsVisualizer/permissions-visualizer-context";
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    env: any;
  }
}

const App: FC = () => {
  const graphQLEndpoint = process.env.REACT_APP_GRAPHQL_ENDPOINT as string;

  return (
    <Sentry.ErrorBoundary>
      <GraphQlClientProvider
        graphQLEndpoint={graphQLEndpoint || ""}
        environment={process.env.NODE_ENV as EnvNames}
      >
        <PermissionsVisualizerContext>
          <LoginHandler>
            <PartnerConfigProvider>
              <DPThemeProvider>
                <CssBaseline />
                <AnalyticsConfig gtmId={process.env.REACT_APP_GTM_ID || ""}>
                  <Router>
                    <Switch>
                      <Route
                        exact
                        path={InternalRoutes.restricted}
                        component={Restricted}
                      />
                      <Route path="/">
                        <SideNav />
                        <TopNav />
                        <InfoBanner />
                        <Routes />
                      </Route>
                    </Switch>
                  </Router>
                </AnalyticsConfig>
              </DPThemeProvider>
            </PartnerConfigProvider>
          </LoginHandler>
        </PermissionsVisualizerContext>
      </GraphQlClientProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
